import { useCallback, useEffect } from "react";
import { MembersGroupUser, CreateMembersGroupUser, UpdateMembersGroupUser } from "../types/models/MembersGroupUser.d";
import { UpdateEntityMembersGroupUser } from "../types/models/MembersGroupUser";
import { useGetMembersGroupUserListQuery, useInsertMembersGroupUserMutation, useDeleteMembersGroupUserMutation, } from "../apis/MembersGroupUser.api";
import { useDeleteDialog, useDescriptionAlert } from '../../share';
import { useNavigate } from "react-router";
import { t } from "@lingui/core/macro";

export default function useMembersGroupUser(page: number, pageSize: number) {

    const navigate = useNavigate()
    const { openDialog, closeDialog } = useDeleteDialog();

    const { openSuccessAlert, openFailAlert } = useDescriptionAlert()

    const [insertMembersGroupUserMutation, { 
        isLoading: insertMembersGroupUserLoading, 
        isSuccess: insertMembersGroupUserIsSuccess,
        isError: insertMembersGroupUserIsError,
        error: insertMembersGroupUserError,
    }] = useInsertMembersGroupUserMutation()
    
    const [deleteMembersGroupUserMutation, { 
        isLoading: deleteMembersGroupUserLoading,
        isSuccess: deleteMembersGroupUserIsSuccess,
        isError: deleteMembersGroupUserIsError,
        error: deleteMembersGroupUserError,
    }] = useDeleteMembersGroupUserMutation()

    const loading =
        insertMembersGroupUserLoading ||
        
        deleteMembersGroupUserLoading ||
        false

    const insertMembersGroupUser = useCallback(async (membersGroupUser: CreateMembersGroupUser, redirectPath: string|undefined) => {
        try {
            const data = await insertMembersGroupUserMutation(membersGroupUser).unwrap()
            if (data) {
                if (redirectPath) {
                    if (redirectPath !== '.') {
                        navigate(redirectPath, {relative: 'path'})
                    }
                } else {
                    navigate(`../${data.id}`, {relative: 'path'})
                }
                return data;
            }
        } catch (e) {
            console.log("add error", e)
            openFailAlert(t`Add error: ` + e.toString())
        }
    }, [insertMembersGroupUserMutation, navigate])
    
    useEffect(() => {
        if (insertMembersGroupUserIsSuccess) {
            openSuccessAlert('Members Group User created')
        } else if (insertMembersGroupUserIsError) {
            console.log("add error", insertMembersGroupUserError)
            openFailAlert(t`Members Group User add error: ` + insertMembersGroupUserError?.data?.message)
        }
    }, [
        insertMembersGroupUserIsSuccess,
        insertMembersGroupUserIsError,
        insertMembersGroupUserError
    ]);

    

    const deleteMembersGroupUser = useCallback((membersGroupUser: MembersGroupUser, redirectPath: string|undefined) => {
        openDialog(async () => {
            membersGroupUser = {
                ...membersGroupUser,
            }
            try {
                const { data } = await deleteMembersGroupUserMutation(membersGroupUser);
                if (data != null) {
                    if (redirectPath) {
                        navigate(redirectPath, {relative: 'path'})
                    }
                }
            } catch (e) {
                console.log("delete error", e)
                openFailAlert(t`Delete error: ` + e.toString())
            }
            closeDialog()
        });
    }, [deleteMembersGroupUserMutation, closeDialog, openDialog])
    
    useEffect(() => {
        if (deleteMembersGroupUserIsSuccess) {
            openSuccessAlert(t`Members Group User deleted`)
        } else if (deleteMembersGroupUserIsError) {
            console.log("delete error", deleteMembersGroupUserError)
            openFailAlert(t`Members Group User delete error: ` + deleteMembersGroupUserError?.data?.message)
        }
    }, [
        deleteMembersGroupUserIsSuccess,
        deleteMembersGroupUserIsError,
        deleteMembersGroupUserError
    ]);

    return {
        loading,
        insertMembersGroupUser,
        
        deleteMembersGroupUser
    }
}
